export default "__VITE_ASSET__BqYF7lZf__"